import noNilArray from 'utils/arrays/noNilArray.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

const GRANTED_CHOICE = 'all_staff';
const DENIED_CHOICE = 'no_access';

export const isAllStaffNoAccessCheckboxChoices = (choices) => {
  const list = noNilArray(choices);
  return list.some(({ key }) => key === GRANTED_CHOICE) && list.some(({ key }) => key === DENIED_CHOICE);
};

export const isChoiceBasedCheckboxChecked = (value) => fromAnyToTrimmed(value) === GRANTED_CHOICE;

export const determineChoiceBasedCheckboxValue = (isChecked) => (isChecked ? DENIED_CHOICE : GRANTED_CHOICE);
